define([
	"csi/def/ActionFactory",
	"./_StateAction"
], function(ActionFactory,_StateAction) {

	return ActionFactory.declare("ReviewApprove", _StateAction, {
		m_tag: "ReviewApprove",
		
		_getStateRoles: function(/*csi.def.Context*/ctx) {
			// summary: currently only used for Size Chart
			return ["Size Chart Evaluation Approver"];
		}
	});
});